import { ReactNode, useEffect, useRef } from "react";
import { Marker, Popup } from "react-leaflet";
import { useLocation, useNavigate } from "react-router-dom";
import type { Icon, LatLngExpression, Map as LeafletMap, Popup as LeafletPopup } from "leaflet";
const title = "Map";

type CustomMarkerProps = {
    position: LatLngExpression;
    icon: Icon;
    isActive: boolean;
    hash: string;
    map: LeafletMap;
    children: ReactNode;
};

export default function CustomMarker({ 
    position, 
    icon,  
    isActive, 
    hash, 
    map, 
    children,
}: CustomMarkerProps){
    //----------------------------------------------------------------------------------------
    const popupRef = useRef<LeafletPopup | null>(null);
    //----------------------------------------------------------------------------------------
    const location = useLocation();
    const navigate = useNavigate();
    useEffect(() => {
        map.whenReady(() => {
            if(isActive && popupRef.current && map){
                popupRef.current.setLatLng(position).openOn(map);
            }else if(!isActive && popupRef.current?.isOpen()){
                map.closePopup(popupRef.current);
            }
        });
    }, [isActive, map, position]);
    //----------------------------------------------------------------------------------------
    const targetPath = `/${title}/${hash}`;
    return (
        <Marker
            position = {position}
            icon = {icon}
            eventHandlers = {{
                popupopen: () => {
                    if(location.pathname !== targetPath){
                        navigate(targetPath, { replace: true });
                    }
                },
                popupclose: () => {
                    if(location.pathname === targetPath){
                        navigate(`/${title}`, { replace: true });
                    }
                }
            }}
        >
            <Popup ref = {popupRef} >
                {children}
            </Popup>
        </Marker>
    );
}
